import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import LensIcon from '@mui/icons-material/Lens'
import NotInterestedIcon from '@mui/icons-material/NotInterested'
import TripOriginIcon from '@mui/icons-material/TripOrigin'
import React from 'react'
import { categoryEntryState } from '~/helpers'
import { notesIconChoices } from '~/types/choices'

const CategoryEntryIcon = ({
  values,
  state,
  ...rest
}: {
  values: any
  state?: 'none' | 'some' | 'all' | undefined
  /** Forwarded to the rendered icon. */
  [key: string]: any
}) => {
  if (!values) return <NotInterestedIcon />
  if (!state && values.category?.attributes)
    state = categoryEntryState(values, values.category).attributesState
  const iconProp = state === 'none' ? 'outlineIcon' : 'icon'
  const notesIcon = notesIconChoices.find((c) => c.id === values.notes_icon)?.[iconProp]
  return notesIcon ? (
    React.createElement(notesIcon, rest)
  ) : state === 'all' ? (
    <CheckCircleIcon color='primary' {...rest} />
  ) : state === 'some' ? (
    <LensIcon {...rest} />
  ) : (
    <TripOriginIcon {...rest} />
  )
}

export default CategoryEntryIcon
